// extracted by mini-css-extract-plugin
export var details = "_ja-0";
export var inspectorPopover = "_ja-1";